import { Injectable, Type } from '@angular/core';
import { BaseApiService } from '@kinet-open-network/client/core/api-client';
import { UserOption } from '../models/user-option.model';

@Injectable({
  providedIn: 'root',
})
export class AuthOptionsService extends BaseApiService<UserOption> {
  override model: Type<UserOption> = UserOption;

  override get endpoint(): string {
    return '/auth/users-options';
  }
}
